import { render, staticRenderFns } from "./WithdrawalAccount.vue?vue&type=template&id=7f9fd318&scoped=true&"
import script from "./WithdrawalAccount.vue?vue&type=script&lang=js&"
export * from "./WithdrawalAccount.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalAccount.vue?vue&type=style&index=0&id=7f9fd318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9fd318",
  null
  
)

export default component.exports